import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { Component, ReactNode } from 'react';

interface ScrollDialogProps {
	open: boolean;
	onClose: () => void;
	title?: any;
	className?: string;
	children: ReactNode;
}

interface UIState {
	open: boolean;
}

class ScrollDialog extends Component<ScrollDialogProps> {
	state: UIState = {
		open: this.props.open,
	};

	render() {
		return (
			<div>
				<Dialog
					open={this.state.open}
					onClose={this.props.onClose}
					scroll={'paper'}
					aria-labelledby="scroll-dialog-title"
					aria-describedby="scroll-dialog-description"
					className={this.props.className ? this.props.className : ''}
				>
					{this.props.title && <DialogTitle id="scroll-dialog-title">{this.props.title}</DialogTitle>}
					<DialogContent dividers={true}>{this.props.children}</DialogContent>
					{/* <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleClose} color="primary">
                                Subscribe
                            </Button>
                        </DialogActions> */}
				</Dialog>
			</div>
		);
	}
}

export default ScrollDialog;
